<template>
    <section id="pricing-plan">
        <div class="demo-spacing-0 mb-1" v-if="userStore.user.isPartOfAnyFamily">
            <div class="alert alert-warning" role="alert">
                <div class="alert-body">
                    {{replaceFamilyPlaceholder(localizationStore.translate("family.plan.warning.message"),userStore.user.familyName)}}
                </div>
            </div>
        </div>
        <!-- title text and switch button -->
        <div class="text-center">
            <h1 class="mt-5">{{ localizationStore.translate("plan.trial.heading") }}</h1>
            <p class="mb-2 pb-75">
                {{ localizationStore.translate("plan.trial.description") }}
            </p>
            <div class="d-flex align-items-center justify-content-center mb-5 pb-50">
                <h6 class="mr-1 mb-0">
                    {{ localizationStore.translate("plan.trial.radio.button.left") }}
                </h6>
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" v-model="planValue" id="priceSwitch" />
                    <label class="custom-control-label" for="priceSwitch"></label>
                </div>
                <h6 class="ml-50 mb-0">
                    {{ localizationStore.translate("plan.trial.radio.button.right") }}
                </h6>
            </div>
        </div>
        <!--/ title text and switch button -->
        <!-- pricing plan cards -->

        <div class="row pricing-card">
            <div class="col-12 col-sm-offset-2 col-sm-10 col-md-12 col-lg-offset-2 col-lg-10 mx-auto">
                <div class="row match-height">
                    <!-- basic plan -->
                    <!-- for loop -->
                    <template v-for="plan in planStore.plans" >
                        <div class="col-12 col-md-4" v-show="plan.plan_occurrance == planType">
                            <div class="card basic-pricing text-center" :class="{ popular: userStore.user.plan == plan.slug }">
                                <div class="card-body d-flex flex-column">
                                    <div v-if="userStore.user.plan == plan.slug" class="pricing-badge text-left">
                                        <div class="badge badge-pill badge-light-primary">Current Plan</div>
                                    </div>
                                    <img :src="plan.plan_image" class="mb-2 mt-5" alt="img-placeholder" />
                                    <h3>{{ plan.title }}</h3>
                                    <p class="card-text">{{ plan.plan_type}}</p>
                                    <div class="annual-plan">
                                        <div class="plan-price mt-2">
                                            <sup class="font-medium-1 font-weight-bold text-primary">$</sup>
                                            <span class="pricing-basic-value font-weight-bolder text-primary">{{ plan.plan_price }} </span>
                                            <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/ {{ plan.plan_occurrance }}</sub>
                                        </div>
                                        <small class="annual-pricing d-none text-muted"></small>
                                        <span v-html="plan.plan_description"></span>

                                    </div>
                                    <button @click="openPurchaseModal(plan.slug)" v-if="!userStore.user.hasPlan" class="btn btn-block btn-outline-success mt-auto">Purchase</button>
                                    <button v-if="userStore.user.plan == plan.slug" class="btn btn-block btn-primary mt-auto">Current Plan</button>
                                    <button @click="swapPlan(plan.slug)" v-if="userStore.user.hasPlan && userStore.user.plan != plan.slug" class="btn btn-block btn-outline-success mt-auto">Swap Plan</button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- for loop end -->

                </div>
            </div>
        </div>
        <!--/ pricing plan cards -->
        <!-- pricing free trial -->
        <div
            v-if="
                settingStore.isSettingFetched
                &&
                (settingStore.trial.enable_banner == 1)
                &&
                this.userStore.user.enableCardPopup
            "
            class="pricing-free-trial"
        >
            <div class="row">
                <div class="col-12 col-lg-10 col-lg-offset-3 mx-auto">
                    <div class="pricing-trial-content d-flex justify-content-between">
                        <div class="text-center text-md-left mt-3">
                            <h3 class="text-primary">{{ localizationStore.translate("plan.message", {days: days}) }}</h3>
                            <h5>{{ localizationStore.translate("plan.trial.full.access.message", {days: days}) }}</h5>
                            <button data-toggle="modal" data-target="#trial-payment-modal" class="btn btn-primary mt-2 mt-lg-3">{{ localizationStore.translate("plan.trial.button.text", {days: days}) }}</button>
                        </div>

                        <!-- image -->
                        <img :src="baseUrl + '/images/illustration/pricing-Illustration.svg'" class="pricing-trial-img img-fluid" alt="svg img" />
                    </div>
                </div>
            </div>
        </div>
        <!--/ pricing free trial -->

        <!-- pricing faq -->
        <div class="pricing-faq">
            <h3 class="text-center">
                {{ localizationStore.translate("plan.faqs.heading") }}
            </h3>
            <p class="text-center">
                {{ localizationStore.translate("plan.faqs.description") }}
            </p>
            <div class="row my-2">
                <div class="col-12 col-lg-10 col-lg-offset-2 mx-auto">
                    <!-- faq collapse -->
                    <div class="collapse-margin collapse-icon" id="accordionExample">
                        <div class="card">
                            <div class="card-header" id="headingTwo" data-toggle="collapse" role="button" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                <span class="lead collapse-title">
                                    Creditfixrr Free Trial
                                </span>
                            </div>
                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                                <div class="card-body">
                                    While you won’t be charged during your free trial, you’ll be upgraded to a paid membership plan automatically at the end of the trial period. For help turning off your Creditfixrr membership automatic renewal, go to
                                    <router-link
                                        :to="{ name: 'user-account' }"
                                    >
                                        Billing
                                    </router-link>
                                    and select the “Cancel Subscription” button.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div class="card-header" id="headingOne" data-toggle="collapse" role="button" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                <span class="lead collapse-title">Monthly Subscriptions</span>
                            </div>

                            <div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#accordionExample">
                                <div class="card-body">
                                    When cancelling a monthly subscription, all future charges associated with future months of your subscription will be cancelled. You may notify us of your intent to cancel at any time; your cancellation will become effective at the end of your current monthly billing period. Your subscription access and/or delivery and accompanying member benefits will continue for the remainder of the current monthly billing period.
                                </div>
                            </div>
                        </div>
                        <div class="card">
                            <div
                                class="card-header"
                                data-toggle="collapse"
                                role="button"
                                data-target="#annually-subscriptions"
                                aria-expanded="false"
                                aria-controls="Annual Subscription Button"
                            >
                                <span class="lead collapse-title">Annual Subscription</span>
                            </div>
                            <div
                                id="annually-subscriptions"
                                class="collapse"
                                aria-labelledby="Annual Subscription"
                                data-parent="#accordionExample"
                            >
                                <div class="card-body">
                                    When cancelling an annual subscription, all future charges associated with future years of your subscription will be cancelled. You may notify us of your intent to cancel at any time; your cancellation will become effective at the end of your current annual billing period. You will not receive a refund, prorated or otherwise, for the remainder of the annual term. However, your subscription access and/or delivery and accompanying member benefits will continue for the remainder of the current annual billing period.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/ pricing faq -->
        <payment-modal
            :id="'trial-payment-modal'"
            :selected-plan="selectedPlan"
        >
            <template #header>
                <div class="d-flex">
                    <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/best-diy-credit-repair-software-official-logo.png" class="mb-2 w-50 mx-auto" alt="creditfixrr">
                </div>
                <h3 class="text-primary text-center mb-1">
                    {{ localizationStore.translate("card.modal.title") }}
                </h3>
                <p>
                    {{ localizationStore.translate("card.modal.description", {days: days}) }}
                </p>
                <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                    <div class="alert-body">
                        <i data-feather="info" class="mr-50 align-middle"></i>
                        <span v-html="message"></span>
                    </div>
                </div>
                <template v-if="userStore.user.role == 'diy_user'">
                    <input
                        type="radio"
                        name="plan"
                        v-model="selectedPlan"
                        :value="planStore.getPlan('pro_monthly', 'slug')"
                        id="plan-one"
                        class="custom-control-input"
                    />
                    <label for="plan-one" class="card radio-box mb-50">
                        <div class="card-body p-75">
                            <div class="d-flex justify-content-between flex-wrap">
                                <h6 class="font-weight-bolder mb-0">
                                    {{ planStore.getPlan("pro_monthly", "title") }}
                                </h6>
                                <h6 class="font-weight-bolder mb-0">
                                    $0
                                    <!-- $ {{ planStore.getPlan("pro_monthly", "plan_price") }} -->
                                </h6>
                            </div>
                        </div>
                    </label>
                    <input
                        type="radio"
                        name="plan"
                        v-model="selectedPlan"
                        :value="planStore.getPlan('family_basic', 'slug')"
                        id="plan-three"
                        class="custom-control-input"
                    />
                    <label for="plan-three" class="card radio-box mb-50">
                        <div class="card-body p-75">
                            <div class="d-flex justify-content-between flex-wrap">
                                <h6 class="font-weight-bolder mb-0">
                                    {{ planStore.getPlan("family_basic", "title") }}
                                </h6>
                                <h6 class="font-weight-bolder mb-0">
                                    $0
                                    <!-- $ {{ planStore.getPlan("family_basic", "plan_price") }} -->
                                </h6>
                            </div>
                        </div>
                    </label>
                </template>
                <template v-else>
                    <input
                        type="radio"
                        name="plan"
                        v-model="selectedPlan"
                        :value="planStore.getPlan('business_monthly', 'slug')"
                        :checked="selectedPlan === planStore.getPlan('business_monthly', 'slug')"
                        id="plan-two"
                        class="custom-control-input"
                    />
                    <label for="plan-two" class="card radio-box mb-50">
                        <div class="card-body p-75">
                            <div class="d-flex justify-content-between flex-wrap">
                                <h6 class="font-weight-bolder mb-0">
                                    {{ planStore.getPlan("business_monthly", "title") }}
                                </h6>
                                <h6 class="font-weight-bolder mb-0">
                                    $0
                                    <!-- $ {{ planStore.getPlan("business_monthly", "plan_price") }} -->
                                </h6>
                            </div>
                        </div>
                    </label>
                </template>
            </template>
            <template #footer="{ pay }">
                <div class="row gy-1 gx-2 mt-75">
                    <div class="col-12 text-center">
                        <button type="button" @click.once="pay" class="btn btn-primary mr-1 mt-1" :key="planStore.paymentBtnKey">
                            {{ localizationStore.translate("card.modal.button.save") }}
                        </button>
                        <button @click="closeModal('#trial-payment-modal')" type="reset" class="btn btn-outline-secondary mt-1 modal-close-btn" data-dismiss="modal" aria-label="Close">
                            {{ localizationStore.translate("card.modal.button.cancel") }}
                        </button>
                    </div>
                </div>
            </template>
        </payment-modal>
        <payment-modal
            :id="'payment-modal'"
            :plan-slug="planSlug"
            :coupon="coupon"
            :intent="intent"
        >
            <template #header>
                <div class="d-flex">
                    <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/best-diy-credit-repair-software-official-logo.png" class="mb-2 w-50 mx-auto" alt="creditfixrr">
                </div>
                <h3 class="text-primary text-center">Payment Information</h3>
                <div v-if="error" class="alert alert-danger mt-1 alert-validation-msg" role="alert">
                    <div class="alert-body">
                        <i data-feather="info" class="mr-50 align-middle"></i>
                        <span v-html="message"></span>
                    </div>
                </div>
            </template>
            <template #form-attributes>
                <div class="col-6 col-md-6">
                    <div class="form-group align-content-md-center mb-0">
                        <label for="coupon">Coupon</label>
                        <input type="text" v-model="coupon" name="coupon" class="form-control"/>
                    </div>
                </div>
            </template>
            <template #footer="{ subscribe }">
                <button @click.once="subscribe" class="btn btn-primary" :key="planStore.paymentBtnKey">
                    Subscribe
                </button>
                <div class="row">
                    <div class="col-12">
                        <p class="mt-1">Payments are processed securely with Industry-Standard SSL Encryption.</p>
                    </div>
                </div>
            </template>
        </payment-modal>
    </section>
</template>

<script>
    import { ref, reactive } from 'vue';
    import { usePlanStore } from '../stores/PlanStore.js'
    import { useUserStore } from '../stores/UserStore.js'
    import { useLocalizationStore } from '../stores/LocalizationStore.js'
    import { useSettingStore } from '../stores/SettingStore.js'
    import { closeModal, hideModal, openModal } from '../utilities/_helpers'
    import PaymentModal from './modals/PaymentComponent'

    export default {
        props: {
        },
        setup()
        {
            return{
                planValue: ref(false),
                planSlug: ref(null),
                selectedPlan: ref(null),
                referral: ref("referral"),
                coupon: ref(null),
                intent:ref(null),
                planStore: usePlanStore(),
                userStore: useUserStore(),
                localizationStore: useLocalizationStore(),
                baseUrl,
                scrollCount: ref(0),
                scrollThreshold: ref(10),
                settingStore: useSettingStore(),
                days: process.env.MIX_TRIAL_DAYS,
                openModal: openModal,
                closeModal: closeModal
            }
        },
        components: {
            PaymentModal
        },
        created () {
        },
        methods:{
            replaceFamilyPlaceholder(text,familyname) {
                const placeholder = ': (:family)';
                const replacement = ' ('+familyname+')';
                return text.replace(placeholder, replacement);
            },
            openPurchaseModal(slug) {
                this.planSlug = slug;
                openModal('#payment-modal');
            },
            swapPlan(slug) {
                var $this = this;
                Swal.fire({
                    title: 'Are you sure you want to swap plan?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                        cancelButton: 'btn btn-outline-danger ml-1'
                    },
                    buttonsStyling: false
                }).then(function (result) {
                    if (result.value) {
                        axios.post(`${$this.baseUrl}/subscriptions/swap`, {
                            plan: slug
                        })
                        .then(function (response) {
                            if(response.data.error == true) {
                                toastr.error(response.data.message, 'Error!');
                                return;
                            }
                            toastr.success(response.data.message, 'Success!');
                            setTimeout(() => {
                                window.location.reload()
                            }, 5000)

                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                    }
                });
            },
            showPopup() {
                this.scrollCount ++;
                if (
                    (this.$route.name == 'billing-plans')
                    &&
                    this.userStore.user.enableCardPopup
                    &&
                    ((localStorage.getItem('enableCardPopup') == true) || (localStorage.getItem('enableCardPopup') == null))
                    &&
                    !$('#trial-payment-modal').hasClass('show')
                    &&
                    this.scrollCount > this.scrollThreshold
                ) {
                    setTimeout(() => {
                        $('#trial-payment-modal').modal('show');
                    }, 2000)
                }
            }
        },
        computed: {
            planType() {
                return this.planValue ? 'Annually' : 'Monthly';
            }
        },
        mounted()
        {
            useSettingStore().fetchSetting();
            if(!_.isEmpty(this.planStore.planData)){
                this.intent = this.planStore.planData.intent.client_secret
            }else{
                this.planStore.fetchPlans();
                this.planStore.fetchCoursesPlans();
            }

        },
        watch: {
            'settingStore.isSettingFetched'(value) {
                if (value && (this.settingStore.trial.enable_popup == 1)) {
                    window.addEventListener('scroll', this.showPopup);
                }
            },
            'planStore.planData'(value){
                this.intent = value.intent.client_secret
            }
        },
    }

</script>
